import { type GasPayload } from '@atlaskit/analytics-gas-types';
import {
	type KnowledgeDiscoveryJiraIntentDetectionModelType,
	type KnowledgeDiscoveryJiraSearchClassificationType,
} from '@atlassian/search-client/knowledge-discovery/types';

export type IntentRouterSelectedAttributes = {
	buttonPosition?: 0 | 1;
	searchSessionId: string;
	selectedMode: string;
	queryClassification: KnowledgeDiscoveryJiraSearchClassificationType;
	queryHash: string;
	queryLength: number;
	wordCount: number;
	networkResponded: boolean;
	modelId?: KnowledgeDiscoveryJiraIntentDetectionModelType;
	cohort?: string;
	patternType?: string;
};

export const onIntentRouterSelected = ({
	attributes,
}: {
	attributes: IntentRouterSelectedAttributes;
}): GasPayload => ({
	source: 'searchDialog',
	eventType: 'ui',
	action: 'selected',
	actionSubject: 'intentRouter',
	actionSubjectId: 'intentRouterSelected',
	attributes,
});
